module.exports = __webpack_public_path__ + "static/media/Butterhead.6ced6d65.webp";